import React from 'react';

function parseAccounts(accounts) {
	console.log('parseAccounts start');
	console.log(accounts);
	var providerAccounts = [];

	accounts.forEach((element, index, accounts) => {
		
		//check if the providerAccount was already added
		if(!providerAccountExists(providerAccounts,element.providerAccountId )){
			var provAccText = '{"providerAccountId":"' + element.providerAccountId + '","providerName":"' + element.providerName + '","accounts":[]}';
			var provAccJsonObj = JSON.parse(provAccText);		
			//create an account object
			providerAccounts.push(provAccJsonObj);
		}

		
		
		for (var i=0; i < providerAccounts.length; i++) {
			if (providerAccounts[i]['providerAccountId'] == element.providerAccountId) {
				var providerAccount = providerAccounts[i];
				//console.log('before');
				//console.log(providerAccount);
				providerAccount['accounts'].push(createAccount(element));
				//console.log('after');
				//console.log(providerAccount);
				providerAccounts.splice(i,1,providerAccount);
				//console.log('providerAccounts');
				//console.log(providerAccounts);

			}
		}
		
		
		
	});
	console.log(providerAccounts);
	console.log("parseAccounts end")

	return providerAccounts;
}

function providerAccountExists(providerAccounts, providerAccountId) {
	//console.log('start providerAccountExists');
	var contains = false
	
	if(providerAccounts.length >0){
		for (var i=0; i < providerAccounts.length; i++) {
			if (providerAccounts[i]['providerAccountId'] == providerAccountId) {
				contains = true;
				break;
			}
		}
	}
	//console.log('end providerAccountExists'+ contains);
	return contains;
  }


  function createAccount(element){
	  
	//console.log('start createAccount');
	delete element.providerAccountId;
	delete element.providerName;
	//console.log(element);
	//console.log('end createAccount');
	return element;

  }



export default parseAccounts;